import { createTranslationService } from '@services/factories';
import {
    cacheTranslationLists,
    cacheTranslations
} from '@utils/cache-translations';

export enum I9DocumentReviewTranslation {
    instructionsTemplate = 'instructionsTemplate',
    documentConfirmCheckboxTemplate = 'documentConfirmCheckboxTemplate',
    confirmAllLegible = 'confirmAllLegible',
    declineButton = 'declineButton',
    resubmitButton = 'resubmitButton',
    confirmButton = 'confirmButton',
    notAllConfirmed = 'notAllConfirmed',
    loadingDocuments = 'loadingDocuments',
    errorLoadingDocuments = 'errorLoadingDocuments',
    resubmitSubtitle = 'resubmitSubtitle',
    resubmitSubtitleWhenReUpload = 'resubmitSubtitleWhenReUpload',
    confirmCorrectDocuments = 'confirmCorrectDocuments',
    confirmLegibleDocumentImages = 'confirmLegibleDocumentImages'
}

export enum I9DocumentReviewTranslationLists {
    optionalInstructions = 'optionalInstructions'
}

export enum GlobalTranslation {
    requestFailure = 'requestFailure',
    instructionsFor = 'instructionsFor'
}

const translationContext = 'documentReview';

export const getDocumentReviewTranslations = () => cacheTranslations(
    createTranslationService(),
    I9DocumentReviewTranslation,
    translationContext
);

export const getDocumentReviewTranslationLists = () => cacheTranslationLists(
    createTranslationService(),
    I9DocumentReviewTranslationLists,
    translationContext
);



// WEBPACK FOOTER //
// ./src/screens/review-section2/document-review/review-translations.ts